  import { useHomeBannersAndTexts } from '@/store'
  import { getImageUrl } from '@/utils'

  export default () => getImageUrl(useHomeBannersAndTexts().pwaConfig.webLogo)
